module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content join-company"
  }, [_c('h2', [_vm._v("请在下方输入公司邀请码：")]), _vm._v(" "), _c('div', {
    staticClass: "b-b m-b-md"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-item"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.invite_code),
      expression: "invite_code",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "公司邀请码",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.invite_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invite_code = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.invite_code))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 n-p-l"
  }, [_c('button', {
    staticClass: "btn btn-md btn-success p-l-r-lg",
    attrs: {
      "type": "button",
      "disabled": !_vm.join_active
    },
    on: {
      "click": function($event) {
        _vm.joinCompany()
      }
    }
  }, [_vm._v("加入公司")])])]), _vm._v(" "), (_vm.company._id) ? _c('div', [_c('div', {
    staticClass: "input-item"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "company-info"
  }, [_vm._v("\n                        公司名称: " + _vm._s(_vm.company.name) + "\n                    ")])])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f5b9e28","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/join-company.vue
// module id = 497
// module chunks = 1